import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';
import { PaginationItemMixin } from './PaginationItemMixin';

/** @class PaginationJumpItemMixin */
/** @method */
export var PaginationJumpItemMixin = function PaginationJumpItemMixin(props) {
  return token({
    marginX: 'PaginationJumpItem.marginX',
    marginY: 'PaginationJumpItem.marginY'
  }, function (_ref) {
    var marginX = _ref.marginX,
      _ref$marginY = _ref.marginY,
      marginY = _ref$marginY === void 0 ? 0 : _ref$marginY;
    return css(["", " margin:", "px ", ";"], PaginationItemMixin(props), marginY, marginX ? marginX + "px" : spaceMixin('xs')(props));
  })(props);
};